import { gql } from '__generated__'

export const GlobalSearchQuery = gql(`
    query GlobalSearch($query: String!) {
        globalSearch(input: { query: $query }) {
            candidates {
                id
                name
                subtitle
            }
            rosters {
                id
                name
                subtitle
            }
            companies {
                id
                name
                subtitle
            }
        }
    }
`)
